import { log } from 'log';
import { useEffect } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { path, prop } from 'js/utils/ramda.util';
import { useSelector, useDispatch } from 'react-redux';
import { SPORTSBOOK_REDUCER } from 'js/store/constants';

import * as actions from '../store/actions';
import { useGetInitParams } from './useGetInitParams';

export const useSportsbookInit = () => {
    const dispatch = useDispatch();
    const initParams = useGetInitParams();
    const sportsbookRootURL = useAppSelector(prop('sportsbookRootURL'));
    const isAppInitError = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitError']));
    const isAppInitialized = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitialized']));
    const isAppInitializing = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitializing']));
    const isIntegrationScriptFetched = useSelector(path([SPORTSBOOK_REDUCER, 'isIntegrationScriptFetched']));
    const isIntegrationScriptFetching = useSelector(path([SPORTSBOOK_REDUCER, 'isIntegrationScriptFetching']));

    useEffect(() => {
        if (isIntegrationScriptFetched && !sportsbookRootURL) {
            log('error', '[SPORTSBOOK | Portal] sportsbook root URL is not configured');

            return;
        }

        if (!isIntegrationScriptFetched || isIntegrationScriptFetching
            || isAppInitialized || isAppInitializing || isAppInitError) {
            return;
        }

        (async () => {
            try {
                log('log', '[SPORTSBOOK | Portal] app inited with params', initParams);
                dispatch(actions.setAppInitializing(true));

                await window.Sportsbook.init(initParams);

                dispatch(actions.setAppInitialized(true));
            } catch (error) {
                log('log', '[SPORTSBOOK | Portal] Sportsbook init error', error);

                dispatch(actions.setAppInitError());
            }
        })();
    }, [
        dispatch,
        initParams,
        isAppInitError,
        isAppInitialized,
        sportsbookRootURL,
        isAppInitializing,
        isIntegrationScriptFetched,
        isIntegrationScriptFetching
    ]);
};
